import React from 'react';

function Emoji(props) {

    if(props.type==="cpu")
    return (
        <span role="img" aria-label="cpu">📝</span>
    );

    // by default return storage
    return (
        <span role="img" aria-label="storage">🗄</span>
    );
}

export default Emoji;
